export default "__VITE_ASSET__blDz46jc__"